import store from '../store';

export default function (to, from, next) {
	const user = store.state.user.user;

	if (user) {
		next({ name: 'myAccount' });
	} else {
		next();
	}
}